import { SxProps, Typography } from "@mui/material"
import InputBlock from "components/controls/input-block"
import EditableText from "components/controls/input-hidden"
import { computed } from "mobx"
import { observer } from "mobx-react-lite"
import blockTypes from "pages/scheme-editor/block-types"
import { useSchemeEditorStore } from "pages/scheme-editor/store"
import BlockState from "pages/scheme-editor/store/block"
import ChainCollector from "../chains/collector"
import ChainPoint from "../chains/point"
import { BlockChainEmitters, BlockContainer, BlockContent, BlockHeader, BlockKey as BlockVisualKey } from "./styled"

type Props = {
  state: BlockState, 
  children: React.ReactNode,
  title?: string,
  withoutKey?: boolean,
  sx?: SxProps
}

const BlockBase = observer(({ state, children, title, sx, withoutKey }: Props) => {

  const store = useSchemeEditorStore()
  const style: React.CSSProperties = {
    top: state.position.top - store.cameraPos.top +'px', 
    left: state.position.left - store.cameraPos.left +'px'
  }
  const key = computed(() => {
    if (!store.showBlockKeys) return ""
    const keys = store.getBlockKey(state.id)
    if (state.data.key === "" && (keys.length === 1 || state.type !== "value")) return ""
    return keys.filter(item => !!item).join(".")
  }).get()

  return (
    <BlockContainer 
      selected={store.selectedBlock === state.id}
      showProps={store.selectedBlock === state.id && store.editPropsMode}
      style={style} 
      sx={sx}
      onMouseDown={(e) => store.onBlockClick(e, state.id)}
      onDoubleClick={(e) => store.onBlockDoubleClick(e, state.id)}
      onContextMenu={(e) => store.onBlockDoubleClick(e, state.id)}
      data-block-id={state.id}
      className="block"
    >
      { store.showBlockKeys && <BlockVisualKey>{ key }</BlockVisualKey> }
      <BlockHeader>
        <ChainCollector state={state} />
        <EditableText 
          {...state.dataProps('name')}
          placeholder="Название блока" 
          sx={{ fontSize: 11, fontWeight: 700, mr: 1 }} 
        />
        <Typography sx={{ fontSize: 9, color: "text.secondary", fontWeight: 600, whiteSpace: "nowrap" }}>
          { title || blockTypes[state.type].title || "Блок" }
        </Typography>
      </BlockHeader>
      <BlockContent>
        { !withoutKey && (
          <InputBlock {...state.dataProps('key')} label="Название ключа" placeholder="Пустой ключ"/>
        )}
        { children }
      </BlockContent>
      <BlockChainEmitters>
        {state.emitters.map((item, index) => (
          <ChainPoint key={index} state={state} title={item} index={index} />
        ))}
      </BlockChainEmitters>
    </BlockContainer>
  )
})

export default BlockBase